import type { IField } from '@/typescript/interfaces/IField';
import type { TSides } from '@/typescript/interfaces/TSide';

/**
 * Tell if a field belongs to the given side of the product.
 * A field without an explicit `side` belongs to the recto: `side` was introduced after the first
 * templates were saved, so legacy fields do not carry one.
 * Every side filter must apply that same rule: a field rendered on a canvas but missing from the
 * list used to reorder that canvas keeps its stacking untouched while every other field is brought
 * to front, so it silently sinks behind them (a full-covering background then hides it).
 * @param field field to test
 * @param side side of the product the field is expected to belong to
 */
function isFieldOnSide(field: IField | undefined, side: TSides): boolean {
    if (side === 'verso') {
        return field?.side === 'verso';
    }
    return field?.side === undefined || field.side === 'recto';
}

export { isFieldOnSide };
